import { render, staticRenderFns } from "./course_file_manage.vue?vue&type=template&id=902bd232&scoped=true&"
import script from "./course_file_manage.vue?vue&type=script&lang=js&"
export * from "./course_file_manage.vue?vue&type=script&lang=js&"
import style0 from "./course_file_manage.vue?vue&type=style&index=0&id=902bd232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902bd232",
  null
  
)

export default component.exports